const Header = () => {
  return (
    <div
      className="text-center mt-4"
      style={{ width: '70%', margin: '0 auto' }}
    >
      <h3 className="mb-3 pt-3">Welcome!</h3>
      <p style={{ fontSize: '0.8rem' }}>
        Book your appointment in a few simple steps: Choose a service, pick your
        date and time, and fill in your details. See you soon! <br />
      </p>
    </div>
  );
};

export default Header;
